module.exports = __webpack_public_path__ + "7c6fd20ee2fd7e976d41fe7f61025696.jpg";